import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";
import { toast } from "sonner";

import Typography from "core/components/Typography";
import Pill from "core/components/Pill";
import Flex from "core/components/Flex";
import useCurrentUser from "core/hooks/useCurrentUser";
import useAuthenticatedMutation from "core/hooks/useAuthenticatedMutation";
import UserForm from "modules/admin/UserForm";
import { updateUserProfileByUserId } from "modules/admin/actions";

const UserProfileGeneralPage = () => {
  const params = useParams();
  const queryClient = useQueryClient();

  const { currentUser } = useCurrentUser();
  const { userId } = params;

  const updateMutationFn = useAuthenticatedMutation(updateUserProfileByUserId);
  const {
    mutate: updateProfile,
    error,
    isPending: isSaving,
  } = useMutation({
    mutationFn: updateMutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["user-profiles", { userId }],
      });
      toast.success("Updated profile successfully!");
    },
  });

  const handleSubmit = (formValues) => {
    updateProfile({
      userId,
      profile: {
        name: formValues.name,
        alternate_email: formValues.alternate_email || null,
      },
    });
  };

  return (
    <div style={{ maxWidth: "450px" }}>
      <Flex
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        marginBottom="5px"
      >
        <Typography variant="h2" noMargin>
          General
        </Typography>
        <div>
          <Pill
            text={currentUser.enabled ? "Enabled" : "Disabled"}
            size="large"
            variant={currentUser.enabled ? "success" : "default"}
            textDataTest="userProfileStatus"
          />
        </div>
      </Flex>
      <UserForm
        onSubmit={handleSubmit}
        defaultValues={currentUser}
        error={error}
        isSubmitting={isSaving}
      />
    </div>
  );
};

export default UserProfileGeneralPage;
